// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { actions } from '@ta/common.state';

type ExternalProps = {|
  name: string,
  local?: boolean,
  children: (open: () => void, isOpen: boolean) => React.Node,
|};

type Props = {|
  ...ExternalProps,
  isOpen: boolean,
  showGlobal: (name: string) => void,
  showLocal: (name: string) => void,
|};

const Opener = ({ name, local, showGlobal, showLocal, isOpen, children }: Props) => {
  const show = local ? showLocal : showGlobal;
  return children(() => show(name), isOpen);
};

Opener.defaultProps = {
  local: false,
};

export default connect<Props, ExternalProps, _, _, _, _>(
  (state, props: ExternalProps) => ({
    isOpen: props.local ? state.overlays.locals[props.name] : state.overlays.global === props.name,
  }),
  {
    showGlobal: actions.overlays.showGlobalOverlay,
    showLocal: actions.overlays.showLocalOverlay,
  },
)(Opener);
